import {
  DatePipe,
  NgClass,
  NgOptimizedImage,
  SlicePipe,
} from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatError, MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment/moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DuoActionDialogComponent } from '../../shared/components/dialogs/duo-action-dialog/duo-action-dialog.component';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { API_PARAMS } from '../../shared/constants/api.constants';
import {
  FULL_DAY_CHECKUP_HOURS,
  ID_LOGIN_TYPE,
  IMAGE_DEPT_NAME,
} from '../../shared/constants/common.constants';
import { API_DATE_FORMAT } from '../../shared/constants/date.constants';
import {
  AvailableBookingInfo,
  AvailableDatesRequest,
  AvailableNutCalInfo,
  BusinessAvailableDatesRequest,
} from '../../shared/interfaces/appointment-time.model';
import { AddExamInfo } from '../../shared/interfaces/reserve-add.model';
import { ExamItemName } from '../../shared/interfaces/reserve-confirm-survey.model';
import {
  BusinessExamInfo,
  BusinessPackageInfo,
  ExamInfo,
  Group,
} from '../../shared/interfaces/reserve-loading.model';
import { AppointmentTimeService } from '../../shared/services/appointment-time.service';
import { AppointmentInfoService } from '../../shared/services/appointment-info.service';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { ToastrService } from 'ngx-toastr';
import { MyReservationService } from '../../shared/services/my-reservation.service';
import {
  ExamItem,
  ModifyPersonalHeathCheckInfoRequest,
  ModifyBusinessHeathCheckInfoRequest,
} from '../../shared/interfaces/my-reservation.model';
import { ModifyExamDietDialogModel } from '../../shared/interfaces/dialogs/modify-exam-diet-dialog.model';
import { ModifyExamDietDialogComponent } from '../../shared/components/dialogs/modify-exam-diet-dialog/modify-exam-diet-dialog.component';
import {
  BusinessCheckupSettingsRequest,
  BusinessCheckupSettingsResponse,
  CheckupSettingsResponse,
  PersonalCheckupSettingsRequest
} from '../../shared/interfaces/appointment-info.model';
import { ApiResponse } from '../../shared/interfaces/api-response.model';
/**
 * 選擇預約時間組件
 */
@Component({
  selector: 'app-appointment-time',
  standalone: true,
  templateUrl: './appointment-time.component.html',
  imports: [
    TranslatePipe,
    MatCalendar,
    MatButton,
    MatInput,
    FormsModule,
    MatError,
    NgOptimizedImage,
    NgClass,
    SlicePipe,
    DatePipe,
    ReactiveFormsModule,
  ],
  styleUrl: './appointment-time.component.scss',
})
export class AppointmentTimeComponent implements OnInit {
  translateService: TranslateService = inject(TranslateService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  appointmentTimeService: AppointmentTimeService = inject(
    AppointmentTimeService
  );
  appointmentInfoService: AppointmentInfoService = inject(AppointmentInfoService);
  dialog: MatDialog = inject(MatDialog);
  router: Router = inject(Router);
  toastr: ToastrService = inject(ToastrService);
  myReservationService: MyReservationService = inject(MyReservationService);
  modifyType: string = '';//是否來自會員中心，用來控制顯示上一步或取消
  
  showError: boolean = false; // 是否顯示錯誤訊息

  today: Date = new Date(); // 當前日期
  startOfFirstMonth = new Date(
    this.today.getFullYear(),
    this.today.getMonth(),
    1
  ); // 顯示的第一個月的第一天
  startOfSecondMonth = new Date(
    this.today.getFullYear(),
    this.today.getMonth() + 1,
    1
  ); // 顯示的第二個月的第一天

  dayType: string = API_PARAMS.DAY_TYPE.HALF_DAY.code; // 健檢時間類型code(全天/半天)
  bookCalInfos: Array<AvailableBookingInfo> = []; // 健檢預約資訊
  nutCalInfos: Array<AvailableNutCalInfo> = []; // 營養諮詢預約資訊

  selectedBookingDate: AvailableBookingInfo | null = null; // 選擇的健檢預約日期
  morningBookingTime: Array<string> | null = null; // 可選的上午健檢預約時間
  afternoonBookingTime: Array<string> | null = null; // 可選的下午健檢預約時間
  selectedBookingTime: string | null = null; // 選擇的健檢預約時間

  selectedNutBookingDate: AvailableNutCalInfo | null = null; // 選擇的營養諮詢預約日期
  morningNutBookingTime: Array<string> | null = null; // 可選的上午營養諮詢預約時間
  afternoonNutBookingTime: Array<string> | null = null; // 可選的下午營養諮詢預約時間
  selectedNutBookingTime: string | null = null; // 選擇的營養諮詢預約時間

  @ViewChild('calendar1') calendar1!: MatCalendar<Date>; // 選擇的雙日期第一個日曆
  @ViewChild('calendar2') calendar2!: MatCalendar<Date>; // 選擇的雙日期第二個日曆
  showCalendar1 = true; // 是否顯示第一個日曆
  showCalendar2 = true; // 是否顯示第二個日曆

  imageCalInfo: boolean = false; // 是否有高階影像
  contactNumberMaxLength: number = 10; // 聯絡電話最大長度
  contactNumberControl = new FormControl('', [
    Validators.required,
    this.phoneValidator.bind(this),
  ]); // 聯絡電話

  nutBookingCalendar = new FormControl('', [
  ]);

  @ViewChildren('fieldRef') fieldRefs!: QueryList<ElementRef>;

  ngOnInit(): void {
    // 將當前預約步驟設置為7
    setTimeout(() => {
      this.sharedStorageService.set('reserveStep', 7);
    });

    this.modifyType = this.sharedStorageService.get('modifyType') ?? '';//是否來自會員中心修改時間("上一步"鈕改顯示"取消")
    const userPlanRequest = this.sharedStorageService.get('userPlanRequest');
    const addList: Array<ExamItemName> =
      this.sharedStorageService
        .get('addExamItemList')
        ?.map((examItem: AddExamInfo) => ({
          examItem: examItem.examItem,
          examName: examItem.examName,
        })) ?? [];

    if (this.isPersonalReserve) {
      // 個人預約
      // 查詢可預約資訊
      const request: AvailableDatesRequest = {
        orgNo: userPlanRequest?.orgNo ?? '',
        gender: userPlanRequest?.gender ?? '',
        price: String(this.sharedStorageService.get('paymentAmount')),
        examItemList:
          this.sharedStorageService
            .get('examItemList')
            ?.map((examItem: ExamInfo) => ({
              examItem: examItem.examItem,
              examName: examItem.examName,
              selectFlag: examItem.selectFlag,
            })) ?? [],
        addList: addList,
      };
      console.log('API查詢可預約request:', request);
      this.appointmentTimeService.getAvailableDates(request).subscribe(res => {
        this.dayType = res.data?.dayType ?? API_PARAMS.DAY_TYPE.HALF_DAY.code;
        this.bookCalInfos = res.data?.bookCalInfos ?? [];
        this.nutCalInfos = res.data?.nutCalInfos ?? [];
        this.imageCalInfo = res.data?.imageCalInfo ?? false;
        console.log('個人預約 API 回應:', res);
        this.initDateTime();
      });

        //如後端有給營養諮詢時間，nutBookingCalendar變必填
        if (this.nutCalInfos && this.nutCalInfos.length > 0) {
          // 設定必填驗證
          this.nutBookingCalendar.setValidators([Validators.required]);
        } else {
          // 清除驗證
          this.nutBookingCalendar.clearValidators();
        }
        // 更新驗證狀態
        this.nutBookingCalendar.updateValueAndValidity();
  
      
    } else {
      // 企業預約
      // 取得企業已選檢項
            const examItemList =
              this.sharedStorageService.get('examItemList') ?? [];
            const newExamItemList = examItemList.map(item => ({
              examItem: item.examItem,
              examName: item.examName
            }));
      
            // 取得加選檢項
            const addList: Array<ExamItemName> =
              this.sharedStorageService
                .get('addExamItemList')
                ?.map((addExamInfo: AddExamInfo) => {
                  return {
                    examItem: addExamInfo.examItem,
                    examName: addExamInfo.examName,
                  };
                }) ?? [];
      
            const businessSelectedPackage = this.sharedStorageService.get('businessSelectedPackage');
            const businessPlanRequest = this.sharedStorageService.get('businessPlanRequest');
            // 查詢企業可預約時間
            const request: BusinessAvailableDatesRequest = {
              orgNo: businessPlanRequest?.orgNo ?? '',
              companyNo: businessPlanRequest?.companyNo ?? '',
              packageNo: businessSelectedPackage?.packageNo ?? '',
              gender: businessPlanRequest?.gender ?? '',
              dayType: businessSelectedPackage?.dayType ?? '',
              bookPeriod: businessSelectedPackage?.bookPeriod ?? '',
              examItemList: newExamItemList,
              addList: addList,
            };
            console.log('企業預約 API 請求參數:', request);
            this.appointmentTimeService
              .getBusinessAvailableDates(request)
              .subscribe(res => {
                this.dayType = businessSelectedPackage?.dayType ?? '';
                this.bookCalInfos = res.data?.bookCalInfos ?? [];
                this.nutCalInfos = res.data?.nutCalInfos ?? [];
                this.imageCalInfo = res.data?.imageCalInfo ?? false;
                console.log('企業預約 API 回應:', res);
                this.initDateTime();
              });
              
    } 
  }

  // 手機號碼驗證器
  phoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value) {
      const phoneRegex = /^\d{10}$/; // 手機號碼為10位數字
      if (!phoneRegex.test(value)) {
        return {
          invalidFormat: this.translateService.instant(
            'error.contact-error.format'
          ),
        };
      }
    }
    return null;
  }

  // 獲取手機號碼錯誤訊息
  getPhoneErrorMessage() {
    const control = this.contactNumberControl;
    if (!control || !control.errors || !this.showError) return '';

    const errors = control.errors;
    if (errors['required']) {
      return this.translateService.instant('error.contact-error.required');
    }
    if (errors['invalidFormat']) {
      return errors['invalidFormat'];
    }
    return '';
  }

  // 是否為個人預約
  get isPersonalReserve(): boolean {
    return (
      this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
    );
  }

  // 取得健檢時間文字(全天/半天)
  get dayTypeText() {
    if (this.dayType === API_PARAMS.DAY_TYPE.FULL_DAY.code) {
      return API_PARAMS.DAY_TYPE.FULL_DAY.name;
    } else if (this.dayType === API_PARAMS.DAY_TYPE.HALF_DAY.code) {
      return API_PARAMS.DAY_TYPE.HALF_DAY.name;
    }
    return '';
  }

  // 健檢預約日期樣式
  get bookingDateClass() {
    return (d: Date) => {
      const dateStr = moment(d).format(API_DATE_FORMAT);
      const matchingInfo = this.bookCalInfos?.find(info => info.bookDate === dateStr);

      if (!matchingInfo || Number(matchingInfo.bookCnt) === 0) {
          // 不可選日或無名額
            return 'non-available-date';
          } else if (Number(matchingInfo.bookCnt) > 2) {
            // 可選日
            return 'available-date';
          } else {
            // 可選日(該日僅剩２個或１個名額)
            return 'available-date-less-than-3';
          }
        };
      }

  // 營養諮詢預約日期樣式
  get nutBookingDateClass() {
    return (d: Date) => {
      const dateStr = moment(d).format(API_DATE_FORMAT);
      if (
        this.nutCalInfos?.some(
          info => info.nutBookDate === dateStr && Number(info.nutBookCnt) > 2
        )
      ) {
        // 可選日
        return 'available-date';
      } else if (this.nutCalInfos?.some(info => info.nutBookDate === dateStr)) {
        // 可選日(該日僅剩２個或１個名額)
        return 'available-date-less-than-3';
      } else {
        // 不可選日
        return 'non-available-date';
      }
    };
  }

  // 健檢預約日期過濾器
  bookingDateFilter = (d: Date | null): boolean => {
    if (!d) return false;
    if (d < this.today) return false;
    const dateStr = moment(d).format(API_DATE_FORMAT);
    return this.bookCalInfos?.some(info => info.bookDate === dateStr && Number(info.bookCnt) > 0) ?? false;
  };

  // 營養諮詢預約日期過濾器
  nutBookingDateFilter = (d: Date | null): boolean => {
    if (!d) return false;
    if (d < this.today) return false;
    // 營養諮詢時間須晚於健檢時間，日期可以相同
    if (this.selectedBookingDate) {
      const bookingDate = moment(this.selectedBookingDate.bookDate, API_DATE_FORMAT).toDate();
      if (d < bookingDate) return false;
    }
    const dateStr = moment(d).format(API_DATE_FORMAT);
    return (
      this.nutCalInfos?.some(info => info.nutBookDate === dateStr) ?? false
    );
  };

  // 點擊選擇健檢預約日期
  selectBookingDate(date: Date | null) {
    if (!date) return;
    const bookingInfo = this.sharedStorageService.get('bookingInfo');
    const selectedBookingDate = bookingInfo?.checkupDate?.bookDate;
    const dateStr = moment(date).format(API_DATE_FORMAT);

    // 如果已選擇的日期與點擊的日期不同，則顯示提醒dialog
    if (selectedBookingDate && selectedBookingDate !== dateStr) {
      if(this.nutCalInfos && this.nutCalInfos.length > 0 || this.imageCalInfo){
        // 有營養諮詢或高階影像，顯示提醒dialog
        const modifySelectedBookingDateDialog = this.dialog.open(
        DuoActionDialogComponent,
        {
          data: {
            title: this.translateService.instant(
              'appointment-time.reselect-date-title'
            ),
            message: this.translateService.instant(
              'appointment-time.reselect-date-message'
            ),
            leftButtonText: this.translateService.instant(
              'common.button.cancel'
            ),
            rightButtonText: this.translateService.instant(
              'appointment-time.reselect-date-button-confirm'
            ),
            leftButtonAction: () => {
              // 取消修改，直接關閉dialog後return
              modifySelectedBookingDateDialog.close(false);
            },
            rightButtonAction: () => {
              modifySelectedBookingDateDialog.close(true);
              this.selectedNutBookingDate = null; // 清除已選擇的營養諮詢預約日期
              this.selectedNutBookingTime = null; // 清除已選擇的營養諮詢預約時間
            },
            showCloseButton: false,
          },
        }
      );

      modifySelectedBookingDateDialog
        .afterClosed()
        .subscribe((result: Boolean) => {
          if (result) {
            this.updateBookingDate(dateStr);
            this.refreshCalendars();
            this.selectedBookingDate = this.bookCalInfos.filter(
              info => info.bookDate === dateStr
            )[0];
            if (this.selectedBookingDate) {
              this.morningBookingTime =
                this.selectedBookingDate.bookTimes.filter(
                  time => Number(time) < 1200
                );
              this.afternoonBookingTime =
                this.selectedBookingDate.bookTimes.filter(
                  time => Number(time) >= 1200
                );
            }
            this.selectedBookingTime = null; // 清除已選擇的健檢預約時間

            // 清空bookingInfo中的日期，避免重複顯示dialog
            if (bookingInfo) {
              bookingInfo.checkupDate = {
                bookDate: '',
                bookTime: '',
              };
              this.sharedStorageService.set('bookingInfo', bookingInfo);
            }
          }
        });
      }else{
        this.updateBookingDate(dateStr);
        this.refreshCalendars();
        // 無營養諮詢或高階影像，直接修改不須dialog
        this.selectedBookingDate = this.bookCalInfos.filter(
              info => info.bookDate === dateStr
            )[0];
            if (this.selectedBookingDate) {
              this.morningBookingTime =
                this.selectedBookingDate.bookTimes.filter(
                  time => Number(time) < 1200
                );
              this.afternoonBookingTime =
                this.selectedBookingDate.bookTimes.filter(
                  time => Number(time) >= 1200
                );
            }
            this.selectedBookingTime = null; // 清除已選擇的健檢預約時間

            // 清空bookingInfo中的日期，避免重複顯示dialog
            if (bookingInfo) {
              bookingInfo.checkupDate = {
                bookDate: '',
                bookTime: '',
              };
              this.sharedStorageService.set('bookingInfo', bookingInfo);
            }
      }
      
    } else {
      this.updateBookingDate(dateStr);
      this.refreshCalendars();
      // 如果沒有已選擇的日期或點擊的日期與已選擇的日期相同，則直接更新選擇的日期
      this.selectedBookingDate = this.bookCalInfos.filter(
        info => info.bookDate === dateStr
      )[0];
      if (this.selectedBookingDate) {
        this.morningBookingTime = this.selectedBookingDate.bookTimes.filter(
          time => Number(time) < 1200
        );
        this.afternoonBookingTime = this.selectedBookingDate.bookTimes.filter(
          time => Number(time) >= 1200
        );
      }
      this.selectedBookingTime = null; // 清除已選擇的健檢預約時間
    }
    console.log('morningBookingTime:', this.morningBookingTime);
    console.log('afternoonBookingTime:', this.afternoonBookingTime);
  }

  // 點擊選擇營養諮詢預約日期
  selectNutBookingDate(date: Date | null) {
    if (!date) return;
    const dateStr = moment(date).format(API_DATE_FORMAT);
    this.selectedNutBookingDate = this.nutCalInfos.filter(
      info => info.nutBookDate === dateStr
    )[0];
    if (this.selectedNutBookingDate) {
      let availableTimes = this.selectedNutBookingDate.nutBookTimes;
      if (this.selectedBookingDate && this.selectedBookingTime) {
        const selectedBookingTimeNum = Number(this.selectedBookingTime);
        availableTimes = availableTimes.filter(
          time => Number(time) > selectedBookingTimeNum
        );
      }
      this.morningNutBookingTime =
        this.selectedNutBookingDate.nutBookTimes.filter(
          time => Number(time) < 1200
        );
      this.afternoonNutBookingTime =
        this.selectedNutBookingDate.nutBookTimes.filter(
          time => Number(time) >= 1200
        );
    }
  }

  // 點擊選擇健檢預約時間
  selectBookingTime(time: string) {
    this.selectedBookingTime = time;
  }

  // 點擊選擇營養諮詢預約時間
  selectNutBookingTime(time: string) {
    this.selectedNutBookingTime = time;
  }

  // 取得選擇的健檢預約日期(日期物件，用於mat-calendar指定selected)
  get selectedBookingCalendar(): Date {
    return this.selectedBookingDate
      ? moment(this.selectedBookingDate.bookDate, API_DATE_FORMAT).toDate()
      : new Date();
  }

  // 取得選擇的營養諮詢預約日期(日期物件，用於mat-calendar指定selected)
  get selectedNutBookingCalendar(): Date {
    return this.selectedNutBookingDate
      ? moment(
          this.selectedNutBookingDate.nutBookDate,
          API_DATE_FORMAT
        ).toDate()
      : new Date();
  }

  // 初始化健檢/營養諮詢日期與時間
  initDateTime() {
    // 初始化健檢日期與時間
    if (this.sharedStorageService.get('bookingInfo')?.checkupDate) {
      this.selectedBookingDate = {
        bookDate: '',
        bookTimes: [],
        bookCnt: '0',
      };
      this.selectBookingDate(
        moment(
          this.sharedStorageService.get('bookingInfo')?.checkupDate.bookDate ??
            '',
          API_DATE_FORMAT
        ).toDate()
      );
      this.selectBookingTime(
        this.sharedStorageService.get('bookingInfo')?.checkupDate.bookTime ?? ''
      );
    }

    // 初始化營養諮詢日期
    if (this.sharedStorageService.get('bookingInfo')?.nutrition) {
      this.selectedNutBookingDate = {
        nutBookDate: '',
        nutBookTimes: [],
        nutBookCnt: 0,
      };
      this.selectNutBookingDate(
        moment(
          this.sharedStorageService.get('bookingInfo')?.nutrition?.bookDate ??
            '',
          API_DATE_FORMAT
        ).toDate()
      );
      this.selectNutBookingTime(
        this.sharedStorageService.get('bookingInfo')?.nutrition?.bookTime ?? ''
      );
    }

    // 初始化聯絡電話
    this.contactNumberControl.setValue(
      this.sharedStorageService.get('bookingInfo')?.imagingContact || this.sharedStorageService.get('createMemberRequest')?.cell || this.sharedStorageService.get('userPlanRequest')?.cell ||''
    );
  }

  //點擊雙日曆切換顯示
  prevMonth() {
    this.startOfFirstMonth = new Date(
      this.startOfFirstMonth.getFullYear(),
      this.startOfFirstMonth.getMonth() - 1,
      1
    );
    this.startOfSecondMonth = new Date(
      this.startOfSecondMonth.getFullYear(),
      this.startOfSecondMonth.getMonth() - 1,
      1
    );
    this.refreshCalendars();
  }

  nextMonth() {
    this.startOfFirstMonth = new Date(
      this.startOfFirstMonth.getFullYear(),
      this.startOfFirstMonth.getMonth() + 1,
      1
    );
    this.startOfSecondMonth = new Date(
      this.startOfSecondMonth.getFullYear(),
      this.startOfSecondMonth.getMonth() + 1,
      1
    );
    this.refreshCalendars();
  }

  refreshCalendars() {
    this.showCalendar1 = false;
    this.showCalendar2 = false;

    setTimeout(() => {
      this.showCalendar1 = true;
      this.showCalendar2 = true;
    }, 0);
  }

  // 取得高階影像檢查項目名稱(使用、分隔)
  get imageItemNames(): string {
    const imageExamItemNames =
      this.sharedStorageService
        .get('examItemList')
        ?.filter((item: ExamInfo) => {
          return item.deptName === IMAGE_DEPT_NAME && item.selectFlag;
        })
        .map(item => item.examName) ?? [];
    const imageAddExamItemNames =
      this.sharedStorageService
        .get('addExamItemList')
        ?.filter((item: AddExamInfo) => item.deptName === IMAGE_DEPT_NAME)
        .map(item => item.examName) ?? [];
    return [...imageExamItemNames, ...imageAddExamItemNames].join('、');
  }

  // 點擊上一步
  previous() { 
    const modifyType = this.sharedStorageService.get('modifyType');
      if(modifyType === 'modifyExam'){
        //來自會員中心調整檢項
        this.router.navigate(['/healthcheck/reserve/reminder']).then();
      }else if(modifyType === 'modifyTime'){
        //來自會員中心調整時間
        this.router.navigate(['/healthcheck/member/mybooking']).then();
      }else{
        this.router.navigate(['/healthcheck/reserve/bookinfo']).then();
      }
  }

  // 點擊確認檢查時間
  confirm() {
    this.showError = true;
    console.log('nutCalInfos 狀態:', this.nutCalInfos);
    console.log('營養諮詢選擇:', {
      selectedNutBookingDate: this.selectedNutBookingDate,
      selectedNutBookingTime: this.selectedNutBookingTime,
    });

    // 修改驗證邏輯：當 nutCalInfos 不為空時，營養諮詢為必填
    const isNutRequired = this.nutCalInfos && this.nutCalInfos.length > 0;
    const isNutValid =
      !isNutRequired ||
      (this.selectedNutBookingDate && this.selectedNutBookingTime);

    if (
      this.selectedBookingDate &&
      this.selectedBookingTime &&
      isNutValid &&
      (!this.imageCalInfo ||
        (this.imageCalInfo && this.contactNumberControl.valid))
    ) {
      const bookingInfo = this.sharedStorageService.get('bookingInfo');
      if (bookingInfo) {
        bookingInfo.dayType = this.dayType;
        bookingInfo.checkupDate = {
          bookDate: this.selectedBookingDate.bookDate,
          bookTime: this.selectedBookingTime,
        };
        // 只在選擇了營養諮詢時儲存
        if (this.selectedNutBookingDate && this.selectedNutBookingTime) {
          bookingInfo.nutrition = {
            bookDate: this.selectedNutBookingDate.nutBookDate,
            bookTime: this.selectedNutBookingTime,
          };
        } else {
          bookingInfo.nutrition = undefined;
        }

        bookingInfo.imagingContact = this.contactNumberControl.value ?? '';
        this.sharedStorageService.set('bookingInfo', bookingInfo);
        console.log('儲存的 bookingInfo:', bookingInfo);
      }
      //頁面導轉
      const modifyType = this.sharedStorageService.get('modifyType');
      if(modifyType === 'modifyExam' || modifyType === 'modifyTime'){
        //來自會員中心調整檢項或改時間
        //更改時間後是否有名額
        //打CB-019/CB-072儲存變更
        const bookData = this.sharedStorageService.get('bookingInfo');
        const addExamItemList = this.sharedStorageService.get('addExamItemList');
        let addList: ExamItem[] = [];
        if(addExamItemList && addExamItemList?.length>0){
          addList = addExamItemList?.map((item) => ({
          examItem: item.examItem,
          examName: item.examName,
          examPrice: item.price,
        }));
        }

        //檢核營養諮詢是否有值
        if(!this.nutCalInfos&& bookData){
          //"nutCalInfos": []則讓bookData.nutrition也等於空陣列
          //避免髒資料(因可能原有營養諮詢後來改沒有)
          bookData.nutrition = this.nutCalInfos;
        }
                    
        //檢核全日檢是否有選午餐了
        let newLunch = bookData?.lunch ||'';
        console.log("午餐:",newLunch);
        console.log("bookData:",bookData);
        console.log("this.dayType:",this.dayType);

        //2025.12.26原邏輯是用dayType全日檢/半日檢判斷，當全日檢被改回半日檢時清午餐，因企業套檢有機會出現有午餐的半日檢，故改為呼叫API當取得午餐選項就會顯示午餐選擇，將不以全日檢/半日檢判斷。
        //企業呼叫CB-074/個人呼叫CB-069時會回傳lunchInfos，有值就表示有午餐選項。
        this.hasLunchOptions().subscribe(hasLunch => {
          if(hasLunch && !newLunch && bookData){
            //有午餐選項又沒選午餐就呼叫餐食dialog(從半日檢修改成全日檢)
            console.log("選餐食");
            const modifyExamDietDialogRef = this.dialog.open(
                  ModifyExamDietDialogComponent,
                  {
                    panelClass: 'modify-dialog',
                    data: {
                      breakfast: bookData.breakfast ?? '',
                      lunch: newLunch ?? '',
                    },
                  }
                );

                modifyExamDietDialogRef
                  .afterClosed()
                  .subscribe((result: ModifyExamDietDialogModel) => {
                    if (!result) return; // 如果沒有結果，則不更新
                    // 儲存更新後的健檢服
                    bookData.breakfast = result.breakfast;
                    bookData.lunch = result.lunch;
                    this.sharedStorageService.set('bookingInfo',bookData);
                    modifyExamDietDialogRef.close();
                    //儲存修改預約內容
                    this.modifyHeathCheckInfo();
                  });

          }else if( !hasLunch && newLunch && bookData){
            //無午餐選項卻選了午餐就清午餐(此情況為原為有午餐方案，但重選方案後變成無午餐方案)
            bookData.lunch ='';
            this.sharedStorageService.set('bookingInfo',bookData);
            //儲存修改預約內容
            this.modifyHeathCheckInfo();
          }else{
            //儲存修改預約內容
            this.modifyHeathCheckInfo();
          }
        });

            
      }else{
        this.router.navigate(['/healthcheck/reserve/review']).then();
      }
      
    } else {
      console.log('驗證失敗:', {
        selectedBookingDate: this.selectedBookingDate,
        selectedBookingTime: this.selectedBookingTime,
        isNutValid: isNutValid,
        contactNumberValid: this.contactNumberControl.valid,
        imageCalInfo: this.imageCalInfo,
      });
      this.scrollToFirstInvalidField();
    }
  }

  // 滾動到第一個無效欄位
  scrollToFirstInvalidField() {
    let firstInvalid: string;
    if (!this.selectedBookingDate || !this.selectedBookingTime) {
      firstInvalid = 'bookingCalendar';
    } else if (
      this.nutCalInfos &&
      this.nutCalInfos.length > 0 &&
      (!this.selectedNutBookingDate || !this.selectedNutBookingTime)
    ) {
      firstInvalid = 'nutBookingCalendar';
    } else if (this.imageCalInfo && this.contactNumberControl.invalid) {
      firstInvalid = 'contactNumber';
    }

    // get the target element with the wanted data-control-name attribute
    const el = this.fieldRefs.find(ref => {
      const nativeEl = ref?.nativeElement;
      return nativeEl?.getAttribute?.('data-control-name') === firstInvalid;
    });

    if (el?.nativeElement) {
      el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.nativeElement.focus?.();
    }
  }

  // 更新健檢預約日期
  updateBookingDate(dateStr: string) {
    this.selectedBookingDate = this.bookCalInfos.filter(
      info => info.bookDate === dateStr
    )[0];
    if (this.selectedBookingDate) {
      this.morningBookingTime = this.selectedBookingDate.bookTimes.filter(
        time => Number(time) < 1200
      );
      this.afternoonBookingTime = this.selectedBookingDate.bookTimes.filter(
        time => Number(time) >= 1200
      );
    }
    this.selectedBookingTime = null; // 清除已選擇的健檢預約時間
    const bookingInfo = this.sharedStorageService.get('bookingInfo');
    if (bookingInfo) {
      bookingInfo.checkupDate = {
        bookDate: '',
        bookTime: '',
      };
      this.sharedStorageService.set('bookingInfo', bookingInfo);
    }
  }
   //儲存修改預約資訊
    modifyHeathCheckInfo(){
    const myReservation = this.sharedStorageService.get('myReservation');
        const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
        const bookData = this.sharedStorageService.get('bookingInfo');
        const paymentAmount = this.sharedStorageService.get('paymentAmount');
        const addExamItemList = this.sharedStorageService.get('addExamItemList');
        let addList: ExamItem[] = [];
        if(addExamItemList && addExamItemList?.length>0){
          addList = addExamItemList?.map((item) => ({
          examItem: item.examItem,
          examName: item.examName,
          examPrice: item.price,
        }));
        }
        
        const contactAddress = (bookData?.city ?? '') 
                     + (bookData?.district ?? '') 
                     + (bookData?.address ?? '');

        let reportAddress = '';
        if(bookData?.deliveryMethod === '9'){
          //國外
          reportAddress = bookData?.foreignAddress ??'';
        }else if(bookData?.deliveryMethod === '0'){
          //國內
          reportAddress = (bookData?.reportCity ?? '') 
                      + (bookData?.reportDistrict ?? '') 
                      + (bookData?.reportAddress ?? '');
        }
        
        if(this.isPersonalReserve){
          // 2026.2.26 PM亮豪spec :原金額>32,000，修改檢項後金額<32,000，在選擇預約時間後，由前端判斷將不會把原”午餐”資訊傳回給後端。
          const paymentAmount = this.sharedStorageService.get("paymentAmount");
          let lunch = bookData?.lunch ?? '';
          if( paymentAmount && paymentAmount<32000 ){
              if(lunch){
                lunch = '';
                console.log('修改檢項後金額<32,000，將無附贈午餐');
              }
          }

          //CB-019個人-修改預約資訊
          const request: ModifyPersonalHeathCheckInfoRequest = {
              caseNo: myReservation?.caseNo??'',
              personalData: {
                idNo: createMemberRequest?.idNo ??'',
                chartNo: createMemberRequest?.chartNo??'',
                address: contactAddress,
                zipCode: bookData?.zipCode,
                langu: bookData?.language,
              },
              examItemData: {
                addList: addList,
              },
              bookData: {
                  orgNo: bookData?.orgNo ??'',
                  price: ''+paymentAmount,
                  bookDate:  this.selectedBookingDate?.bookDate ?? bookData?.checkupDate.bookDate ??'',
                  bookTime:  this.selectedBookingTime ?? bookData?.checkupDate.bookTime ??'',
                  nutBookDate:  this.selectedNutBookingDate?.nutBookDate ?? bookData?.nutrition?.bookDate??'',
                  nutBookTime:  this.selectedNutBookingTime?? bookData?.nutrition?.bookTime ??'',
                  imagingContact: this.contactNumberControl.value ?? '',
                  deliveryType: bookData?.deliveryMethod,
                  isContactAddress: reportAddress===contactAddress?true:false,
                  zipCode: bookData?.deliveryMethod === '0' ? bookData?.reportZipCode : '',
                  deliveryAddress: reportAddress,
                  recipient: bookData?.recipient ? bookData?.recipient : createMemberRequest?.name ,
                  recipientCell: bookData?.recipient ? bookData?.recipientCell ||'0' : createMemberRequest?.cell ||'0',
                  clothesSize: bookData?.clothesSize,
                  breakfast: bookData?.breakfast,
                  lunch: lunch ?? '',
                  },
                  imageCalInfo:  this.imageCalInfo ? true :false,
                };
              console.log('CB-019 request:', request);  
              this.myReservationService.modifyPersonalHeathCheckInfo(request).subscribe(res => {
                  if (res.success) {
                    this.toastr.success(
                        this.translateService.instant('my-reservation.modify-reservation-success')
                      );
                    //低渣飲食名單
                      const prompt=['L4002800','L4001310','L9022400','LI004700','TF031000A','LB000401'];  
                      const hasMatch = addList.some(item => prompt.includes(item.examItem));
                      if (hasMatch) {
                        console.log("調整檢項有符合低渣項目");
                        const matchExamDialog = this.dialog.open(
                                    SingleActionDialogComponent,
                                    {
                                      data: {
                                        title: this.translateService.instant(
                                          'my-reservation.modify-specific-item.title'
                                        ),
                                        message: this.translateService.instant(
                                          'my-reservation.modify-specific-item.text'
                                        ),
                                        buttonText: this.translateService.instant(
                                          'my-reservation.modify-specific-item.button'
                                        ),
                                        showCloseButton: false,
                                        action: () => {
                                          matchExamDialog.close();
                                          this.sharedStorageService.clear();
                                          this.router.navigate(['healthcheck/member/mybooking']).then();
                                        },
                                      },
                                    }
                                  );
                      } else {
                        console.log("調整檢項無符合低渣項目");
                        this.sharedStorageService.clear();
                      this.router.navigate(['/healthcheck/member/mybooking']).then();
                      }     
                  }else{
                    if(res.statusCode ==='EC2003'){
                      const quotaFilledDialog = this.dialog.open(
                                    SingleActionDialogComponent,
                                    {
                                      data: {
                                        title: this.translateService.instant(
                                          'appointment-time.quota-filled'
                                        ),
                                        buttonText: this.translateService.instant(
                                          'my-reservation.modify-specific-item.button'
                                        ),
                                        showCloseButton: false,
                                        action: () => {
                                          quotaFilledDialog.close();
                                        },
                                      },
                                    }
                                  );
                    }else{
                      this.toastr.error(
                      //留在時間頁
                        this.translateService.instant('my-reservation.modify-reservation-error')
                      );
                    }
                    
                  }
                });
        }else{
          //CB-072企業-修改預約資訊
          const myReservation = this.sharedStorageService.get('myReservation');
          const businessSelectedPackage = this.sharedStorageService.get('businessSelectedPackage');
          const examItemList = this.sharedStorageService.get('examItemList') ?? [];
          const newExamItemList = examItemList.map(item => ({
            examItem: item.examItem,
            examName: item.examName
          }));

          let isContactAddress = false;
          let deliveryType = bookData?.deliveryMethod;
          if(deliveryType === '2' || deliveryType === '3'|| deliveryType === '99'){
            deliveryType = '';//2 承辦領取、3 統一給業務、99 其他
            isContactAddress = false;
          }else if(deliveryType === '0'){
            isContactAddress = reportAddress===contactAddress?true:false;
          }else if(deliveryType === '9'){
            isContactAddress = false;
          }
          console.log("deliveryType:",deliveryType);
          console.log("isContactAddress:",isContactAddress);

          //CB-072 企業修改預約資訊
          const request: ModifyBusinessHeathCheckInfoRequest = {
              caseNo: myReservation?.caseNo??'',
              personalData: {
                idNo: createMemberRequest?.idNo ??'',
                chartNo: createMemberRequest?.chartNo??'',
                address: contactAddress,
                zipCode: bookData?.zipCode,
                langu: bookData?.language,
              },
              examItemData: {
                examItemList: newExamItemList,
                addList: addList,
              },
              bookData: {
                  orgNo: bookData?.orgNo ??'',
                  companyNo: myReservation?.companyNo ??'',
                  familyFlag: myReservation?.familyFlag ??'',
                  packageNo: businessSelectedPackage?.packageNo ??'',
                  price: ''+paymentAmount,
                  bookDate:  this.selectedBookingDate?.bookDate ?? bookData?.checkupDate.bookDate ??'',
                  bookTime:  this.selectedBookingTime ?? bookData?.checkupDate.bookTime ??'',
                  nutBookDate:  this.selectedNutBookingDate?.nutBookDate ?? bookData?.nutrition?.bookDate??'',
                  nutBookTime:  this.selectedNutBookingTime?? bookData?.nutrition?.bookTime ??'',
                  imagingContact: this.contactNumberControl.value ?? '',
                  deliveryType: deliveryType,
                  isContactAddress: isContactAddress,
                  zipCode: bookData?.deliveryMethod === '0' ? bookData?.reportZipCode : '',
                  deliveryAddress: reportAddress,
                  recipient: bookData?.recipient ? bookData?.recipient : createMemberRequest?.name ,
                  recipientCell: bookData?.recipient ? bookData?.recipientCell ||'0' : createMemberRequest?.cell ||'0',
                  clothesSize: bookData?.clothesSize,
                  breakfast: bookData?.breakfast,
                  lunch: bookData?.lunch ||'',
                  },
                  imageCalInfo:  this.imageCalInfo ? true :false,
                };
              console.log('CB-072 request:', request);
              this.myReservationService.modifyBusinessHeathCheckInfo(request).subscribe(res => {
                  if (res.success) {
                    this.toastr.success(
                        this.translateService.instant('my-reservation.modify-reservation-success')
                      );
                    
                      this.sharedStorageService.clear();
                      this.router.navigate(['/healthcheck/member/mybooking']).then();
                      
                  }else{
                    if(res.statusCode ==='EC2003'){
                      const quotaFilledDialog = this.dialog.open(
                                    SingleActionDialogComponent,
                                    {
                                      data: {
                                        title: this.translateService.instant(
                                          'appointment-time.quota-filled'
                                        ),
                                        buttonText: this.translateService.instant(
                                          'my-reservation.modify-specific-item.button'
                                        ),
                                        showCloseButton: false,
                                        action: () => {
                                          quotaFilledDialog.close();
                                        },
                                      },
                                    }
                                  );
                    }else{
                      this.toastr.error(
                      //留在時間頁
                        this.translateService.instant('my-reservation.modify-reservation-error')
                      );
                    }

                  }
                });
        }
  }
  //確認是否有午餐，用於修改預約資料(情境為預約時無午餐，修改檢項時加選加到多出午餐)
  hasLunchOptions(): Observable<boolean> {
    if(this.isPersonalReserve){
      //個人CB-069
      // 取得預約檢項
            const sharedStorageExamItemList =
            this.sharedStorageService.get('examItemList') ?? [];
            const newExamItemList = sharedStorageExamItemList.map(item => ({
              examItem: item.examItem,
              examName: item.examName,
              selectFlag: item.selectFlag ?? 0,
            }))?? [];
            // 取得加選檢項
          const addList: Array<ExamItemName> =
            this.sharedStorageService
              .get('addExamItemList')
              ?.map((addExamInfo: AddExamInfo) => {
                return {
                  examItem: addExamInfo.examItem,
                  examName: addExamInfo.examName,
                };
              }) ?? [];

            const userPlanRequest = this.sharedStorageService.get('userPlanRequest');
            const myReservation = this.sharedStorageService.get('myReservation');
            const request: PersonalCheckupSettingsRequest = {
                dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.ALL,
                caseNo: myReservation?.caseNo ?? this.sharedStorageService.get('caseNo') ??'',
                companyNo: '1150',
                orgNo: userPlanRequest?.orgNo ?? '',
                gender: userPlanRequest?.gender ?? '',
                idNo: userPlanRequest?.idNo ?? '',
                UUID: userPlanRequest?.uuid ?? '',
                bookDate: myReservation?.bookDate ?? '',
                examItemList: newExamItemList ,
                addList: addList,
              };
            return this.appointmentInfoService.checkupSettings(request).pipe(
              map((res: ApiResponse<CheckupSettingsResponse>) => {
                if(res.data?.lunchInfos && res.data?.lunchInfos.length > 0){
                  return true;
                }else{
                  return false;
                }
              })
            );
    }else{
      //企業CB-074
      // 取得預約檢項
          const sharedStorageExamItemList =
            this.sharedStorageService.get('examItemList') ?? [];
          const newExamItemList = sharedStorageExamItemList.map(item => ({
            examItem: item.examItem,
            examName: item.examName
          }));
          // 取得加選檢項
          const sharedStorageAddList =
            this.sharedStorageService.get('addExamItemList')?? [];
          const addList = sharedStorageAddList.map(item => ({
            examItem: item.examItem,
            examName: item.examName
          }));
          const businessPlanRequest = this.sharedStorageService.get('businessPlanRequest');
          const idLoginRequest = this.sharedStorageService.get('idLoginRequest');//走漸進式登入
          const businessLoginInfo = this.sharedStorageService.get('businessLoginInfo');//走會員登入
          const createMemberRequest = this.sharedStorageService.get('createMemberRequest');//走會員登入
          const bookingInfo = this.sharedStorageService.get('bookingInfo');
          const myReservation = this.sharedStorageService.get('myReservation');
          const request: BusinessCheckupSettingsRequest = {
                  dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.DIET,
                  caseNo: myReservation?.caseNo ?? this.sharedStorageService.get('caseNo') ??'',
                  companyNo: businessPlanRequest?.companyNo ?? myReservation?.companyNo ??'',
                  familyFlag: idLoginRequest?.identity ?? businessLoginInfo?.identity ?? myReservation?.familyFlag ?? API_PARAMS.IDENTITY.EMPLOYEE,
                  orgNo: businessPlanRequest?.orgNo ?? bookingInfo?.orgNo ?? '',
                  gender: businessPlanRequest?.gender ?? createMemberRequest?.gender ?? '',
                  idNo: idLoginRequest?.idNo ?? createMemberRequest?.idNo ?? '',
                  bookDate: myReservation?.bookDate ?? '',
                  examItemList: newExamItemList,
                  addList: addList,
                };
                console.log('企業檢查request:', request);
                return this.appointmentInfoService
                  .businessCheckupSettings(request)
                  .pipe(
                    map((res: ApiResponse<BusinessCheckupSettingsResponse>) => {
                      if(res.data?.lunchInfos && res.data?.lunchInfos.length > 0){
                        return true;
                      }else{
                        return false;
                      }
                    })
                  );
    }
  }

  protected readonly Number = Number;
  protected readonly API_PARAMS = API_PARAMS;
  protected readonly FULL_DAY_CHECKUP_HOURS = FULL_DAY_CHECKUP_HOURS;
  protected readonly moment = moment;
  protected readonly API_DATE_FORMAT = API_DATE_FORMAT;
  protected readonly window = window;
}
